import { SET_ACTIVE_HOOK } from './actionTypes';

export const setActiveHook = hook => {
  return {
    type: SET_ACTIVE_HOOK,
    hook,
  };
};
